// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { TextInput, SharedTextInputProps } from "./text_input";

export const TextArea = (props: SharedTextInputProps) => {
  const { rows = 4, ...remainingProps } = props;

  return <TextInput multiline rows={rows} {...remainingProps} />;
};
